import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../../loader/Loader';
import NicheLandingPage from './NicheLandingPage';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

export default function HandymenMain() {
    const { t, locale } = useLocale();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) return <Loader />;

    return (
        <Fragment>
            <PageSEO title={t('niche.handymen.metaTitle')} description={t('niche.handymen.metaDescription')} path="/handymen" locale={locale} />
            <NicheLandingPage nicheKey="handymen" />
        </Fragment>
    );
}
